import { Button } from 'react-bootstrap';
import type { CompetitorInsight } from '../../types';
import type { useNewPromptForm } from '../NewPromptForm';
import type { PromptSetupPhase, SetupStep } from './types';

type PromptForm = ReturnType<typeof useNewPromptForm>;

type SetupModalFooterProps = {
  step: SetupStep;
  ensuringProject: boolean;
  hasValidDomain: boolean;
  hasCompetitors: boolean;
  competitors: CompetitorInsight[];
  creatingPrompt: boolean;
  promptForm: PromptForm;
  promptPhase: PromptSetupPhase;
  hasPrompts: boolean;
  onContinueToPrompt: () => void;
  onFinish: () => void;
};

export function SetupModalFooter({
  step,
  ensuringProject,
  hasValidDomain,
  hasCompetitors,
  competitors,
  creatingPrompt,
  promptForm,
  promptPhase,
  hasPrompts,
  onContinueToPrompt,
  onFinish,
}: SetupModalFooterProps) {
  if (step === 'info') {
    return (
      <Button
        type="submit"
        form="setup-info-form"
        variant="falcon-primary"
        className="px-3"
        disabled={ensuringProject || !hasValidDomain}
      >
        {ensuringProject ? 'در حال ایجاد…' : 'ادامه'}
      </Button>
    );
  }

  if (step === 'competitor') {
    return (
      <Button
        variant="falcon-primary"
        className="px-3"
        onClick={onContinueToPrompt}
        disabled={!hasCompetitors}
      >
        ادامه
        {hasCompetitors ? ` (${competitors.length})` : ''}
      </Button>
    );
  }

  if (promptPhase === 'tracking') {
    return (
      <Button variant="falcon-primary" size="sm" disabled>
        در حال ردیابی…
      </Button>
    );
  }

  if (promptPhase === 'done' || hasPrompts) {
    return (
      <Button variant="falcon-primary" size="sm" onClick={onFinish}>
        شروع کنید
      </Button>
    );
  }

  const saveLabel = creatingPrompt
    ? 'در حال ذخیره…'
    : promptForm.promptLines.length > 1
      ? `ذخیره (${promptForm.promptLines.length})`
      : 'ذخیره';

  return (
    <Button
      type="submit"
      form="setup-prompt-form"
      variant="falcon-primary"
      disabled={creatingPrompt || !promptForm.canSubmit}
    >
      {saveLabel}
    </Button>
  );
}
